<template>
  <div
    v-if="layout === 'custom'"
    class="position-absolute w-100 min-height-400 top-0"
    :style="{
      'background-image': 'url(' + image + ')',
      'background-position-y': '50%',
      'z-index': -1,
      'background-repeat': 'no-repeat',
      'background-size': 'cover',
    }"
  >
    <span class="mask bg-black opacity-6"></span>
  </div>
  <div
    v-show="layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-trasnparent' : 'bg-success'}`"
  ></div>

  <aside
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-4"
    :class="` ${sidebarType} ${
      isRTL ? 'fixed-end me-3 rotate-caret' : 'fixed-start ms-3'
    } ${layout === 'landing' ? 'bg-transparent shadow-none' : ''}`"
  >
    <div class="sidenav-header">
      <i
        id="iconSidenav"
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
      ></i>

      <router-link class="m-0 navbar-brand" :to="'isUserManagerRole === true' ? '/manage/users' : '/dashboards/home'" style="cursor: pointer;">
        <img
          v-if="isPinned"
          id="genodyne-logo"
          :src="
            layout === 'landing' || darkMode || sidebarType === 'bg-default'
              ? logoWhite
              : logo
          "
          class="navbar-brand-img h-100"
          alt="Genodyne logo"
        />
        <img
          v-else
          id="genodyne-icon"
          :src="
            layout === 'landing' || darkMode || sidebarType === 'bg-default'
              ? logoOnlyWhite
              : logoOnly
          "
          class="navbar-brand-img h-100"
          alt="Genodyne icon"
        />
      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
     <side-nav-list-v2 v-if="showSidenav" />
  </aside>
</template>
<script>
import SideNavListV2 from "./SidenavListV2.vue";
import logo from "@/assets/img/logo-ct-dark.png";
import logoWhite from "@/assets/img/logo-ct.png";
import logoOnly from "@/assets/img/logo-only-dark.png";
import logoOnlyWhite from "@/assets/img/logo-only.png";
import image from "@/assets/img/bg-weight-lifting.jpg";
import Constants from "@/helpers/constants";


import { mapState } from "vuex";
export default {
  name: "Index",
  components: {
    SideNavListV2
  },
  mounted() {
    this.$store.state.image = image;
    let loggedInUser = this.$store.getters["auth/getLoggedInUser"]();
    if (loggedInUser && loggedInUser.role) {
      this.isUserManagerRole = loggedInUser.role.role_id === Constants.ROLES.USER_MANAGER;
    }
  },
  data() {
    return {
      logo,
      logoWhite,
      logoOnly,
      logoOnlyWhite,
      image,
      isUserManagerRole: false,
    };
  },
  computed: {
    ...mapState(["layout", "isRTL", "sidebarType", "darkMode", "isPinned", "showSidenav"]),
  },
  beforeUnmount() {
    this.$store.state.image;
  },
};
</script>
